module.exports = __webpack_public_path__ + "static/media/ai_network.9fb450ce.png";